import React from "react"
import FadeIn from "../general/fadein.tsx"
import FadeInTop from "../general/fadeintop.tsx"
import petconnect from "../../images/petconnect/petconnect_large.png"
import spreadsheet from "../../images/petconnect/spreadsheet.png"
import websitepreview from "../../images/petconnect/websitepreview.png"
function PetConnect() {
    const transition = {
        transition: ".3s"
    }
    const landing_page = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Landing Page Preview.</p>
        <br></br>
        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={websitepreview}
            alt="Website Preview"
        />
    </div>)
    const spreadsheet_page = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Google Spreadsheet Database allowing any non-technical individuals to edit the website.</p>

        <img
            className=" h-108 rounded-md object-fill object-center pt-5 shadow-xl"
            src={spreadsheet}
            alt="PetConnect Spreadsheet"
        />
    </div>)
    const top = (<div className="grid grid-cols-2 w-2/3 m-auto mt-5 ">
        <div className="text-center m-auto p-5 ">
            <img
                className=" h-96 w-108 object-fill object-center"
                src={petconnect}
                alt="Pet Connect Logo"
            />

        </div>
        <div className="flex flex-row text-left  p-5 items-center">
            <div>
                <h1 className="text-3xl sm:text-5xl font-semibold">PetConnect</h1>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://petconnect.pythonanywhere.com/">Live Site</a><br></br>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://github.com/Datlightning/PetConnectWebsite">GitHub</a>
                <p className="text-l sm:text-2xl">Created with Python Flask for the backend and Bootstrap, CSS, HTML and JavaScript for the frontend.</p>
            </div>
        </div>
    </div>)
    return (
        <>
            <div className="divide-y divide-black/50 w-3/4 m-auto">
                <FadeInTop html={top}/>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                <FadeIn html={landing_page} left={true}/>
                <FadeIn html={spreadsheet_page} left={false}/>
                    

                </div>
            </div>
        </>
    );
}
export default PetConnect;